import React,{useContext} from 'react';
import {FaMoon,FaSun} from 'react-icons/fa';
import {ThemeContext} from '../context/ThemeContext';

export default function ThemeToggle(){
  const {theme,toggleTheme}=useContext(ThemeContext);
  return <button className="nav-icon-button" type="button" onClick={toggleTheme} aria-label={`Switch to ${theme==='light'?'dark':'light'} theme`} title={`Switch to ${theme==='light'?'dark':'light'} theme`}>{theme==='light'?<FaMoon aria-hidden="true"/>:<FaSun aria-hidden="true"/>}</button>;
}
